<template>
  <!-- <div>
    <el-main>
      <ul>
        <li
          v-for="(it, idx) in investList"
          :key="idx"
          class="news_item"
          @click="fnToArticle(it.info_id)"
        >
          <el-image :src="it.main_image" fit="cover"></el-image>
          <div class="news_item_info">
            <h3>{{ it.title }}</h3>
            <div class="news_item_time">
              <div>{{ $dayjs(it.publish_time).format("YYYY-MM-DD") }}</div>
            </div>
            <div class="news_item_desc" v-if="it.desctext">
              {{ it.desctext }}
            </div>
          </div>
        </li>
      </ul>
    </el-main>
  </div> -->
  <div class="investList">
    <el-main v-if="isPc">
      <el-tabs v-model="active" tab-position="left" @tab-click="handleClick">
        <el-tab-pane label="需求列表" name="0">
          <el-row :gutter="20" v-if="needListRes.length > 0">
            <el-col :span="8" v-for="(it, idx) in needListRes" :key="idx">
              <div class="news_item" @click="fnToNeed(it.demand_id)">
                <el-image :src="it.main_image[0]" fit="cover"></el-image>
                <div class="news_item_info">
                  <h3>{{ it.title }}</h3>
                  <div class="types red" v-if="it.demand_type == 0">采購</div>
                  <div class="types" v-if="it.demand_type == 1">出售轉讓</div>
                  <div class="news_item_time">
                    <div>
                      {{ $dayjs(it.end_time).format("YYYY-MM-DD") }} 截止
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- <article-list :article_type="item.type_id"></article-list> -->
        </el-tab-pane>
        <el-tab-pane label="+ 發布采購" name="1">
          <el-tabs class="need-tabs">
            <el-tab-pane>
              <span slot="label">
                <div class="type-card">
                  <img src="../assets/imgs/need01.png" />
                  <h3>采購訂單</h3>
                  <p>
                    采購貨物，比如工業設備、服飾生鮮、家居生活、數碼設備、圖書等等
                  </p>
                </div>
              </span>
              <div class="needs-form">
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i> 標題：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="needsForm.title"
                      placeholder="提煉需求內容，比如XXXXXXXX，建議填寫多種標簽名稱，20字以內"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>圖片：</el-col>
                  <el-col :span="16">
                    <el-upload
                      action="https://upload.qiniup.com/"
                      :data="qn"
                      list-type="picture-card"
                      :on-success="handleLogoSuccess"
                      :before-upload="beforeAvatarUpload"
                      :on-remove="handleRemove"
                      :limit="5"
                      :file-list="fileList"
                    >
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <p slot="tip" class="tips">
                        您需要最少上傳 1
                        張圖片用於描述您的需求，建議上傳需求的全貌，最多可上傳 5
                        張
                      </p>
                    </el-upload>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>采購量：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="needsForm.params[0].value"
                      placeholder="采購數額（請標明單位）"
                    ></el-input>
                  </el-col>
                  <!-- <el-col :span="2">
                    <p class="tips">請標明單位</p>
                  </el-col> -->
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">截止日期：</el-col>
                  <el-col :span="16">
                    <el-date-picker
                      v-model="needsForm.end_time"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="timestamp"
                      type="date"
                      placeholder="采購截止日期"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">采購需求：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="needsForm.params[1].value"
                      placeholder="比如品質、商品規格等要求信息"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">交貨需求：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="needsForm.params[2].value"
                      placeholder="比如交貨方式，交貨地點"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">其他：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="needsForm.params[3].value"
                      placeholder="額外的備註內容（選填）"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>聯系電話：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="needsForm.params[4].value"
                      placeholder="建議使用您賬號相同的手機號"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"></el-col>
                  <el-col :span="4" class="tag">
                    <el-button type="primary" @click="pubilsh(0)">
                      發布需求
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label">
                <div class="type-card">
                  <img src="../assets/imgs/need02.png" />
                  <h3>出售轉讓</h3>
                  <p>處理房產地皮、公司轉讓，這裏填寫出售轉讓的信息描述等等</p>
                </div>
              </span>
              <div class="needs-form">
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>輸入需求地址：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.addr"
                      placeholder="填寫詳細的需求地址 "
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>資產名稱：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.title"
                      placeholder="提煉需求內容，比如XXXXXXXX，建議填寫多種標簽名稱，20字以內"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>圖片：</el-col>
                  <el-col :span="16">
                    <el-upload
                      action="https://upload.qiniup.com/"
                      :data="qn"
                      list-type="picture-card"
                      :on-success="handleLogoSuccess2"
                      :before-upload="beforeAvatarUpload2"
                      :on-remove="handleRemove2"
                      :limit="5"
                      :file-list="fileList2"
                    >
                      <i class="el-icon-plus"></i>
                      <p slot="tip" class="tips">
                        您需要最少上傳 1
                        張圖片用於描述您的需求，建議上傳需求的全貌，最多可上傳 5
                        張
                      </p>
                    </el-upload>
                    <!-- <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog> -->
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i> 訴求：</el-col>
                  <el-col :span="16">
                    <el-radio
                      v-model="saleForm.params[0].value"
                      label="出售"
                      border
                    >
                      出售
                    </el-radio>
                    <el-radio
                      v-model="saleForm.params[0].value"
                      label="轉讓"
                      border
                    >
                      轉讓
                    </el-radio>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>價格：</el-col>
                  <el-col :span="16">
                    <el-col :span="6">
                      <el-radio
                        v-model="saleForm.params[1].value"
                        label="價格面議"
                        border
                      >
                        價格面議
                      </el-radio>
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="saleForm.params[1].value"
                        placeholder="总价或每平米單價"
                      ></el-input>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">截止日期：</el-col>
                  <el-col :span="16">
                    <!-- <el-input
                      v-model="saleForm.end_time"
                      placeholder="采購截止日期"
                    ></el-input> -->
                    <el-date-picker
                      v-model="saleForm.end_time"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="timestamp"
                      type="date"
                      placeholder="截止日期"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">面積：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.params[2].value"
                      placeholder="比如總建築面積、產證面積"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">類型：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.params[3].value"
                      placeholder="比如商場、寫字樓"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>有無商業糾紛：</el-col>
                  <el-col :span="16">
                    <el-radio
                      v-model="saleForm.params[4].value"
                      label="有"
                      border
                    >
                      有
                    </el-radio>
                    <el-radio
                      v-model="saleForm.params[4].value"
                      label="無"
                      border
                    >
                      無
                    </el-radio>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">亮點：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="saleForm.params[5].value"
                      placeholder="…"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag">其他：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="saleForm.params[6].value"
                      placeholder="額外的備註內容（選填）"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"><i>*</i>聯系電話：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.params[7].value"
                      placeholder="建議使用您賬號相同的手機號"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"></el-col>
                  <el-col :span="4" class="tag">
                    <el-button type="primary" @click="pubilsh(1)">
                      發布需求
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
      <!-- <div class="public-btn">
        <button>+ 发布采购</button>
      </div> -->
    </el-main>
    <div v-else>
      <el-tabs class="m-tabs" v-model="active" tab-position="top">
        <el-tab-pane label="需求列表" name="0">
          <el-row :gutter="20" v-if="needListRes.length > 0" class="need-lists">
            <el-col :span="12" v-for="(it, idx) in needListRes" :key="idx">
              <div class="news_item" @click="fnToNeed(it.demand_id)">
                <el-image :src="it.main_image[0]" fit="contain"></el-image>
                <div class="news_item_info">
                  <h3>{{ it.title }}</h3>
                  <div class="types red" v-if="it.demand_type == 0">采購</div>
                  <div class="types" v-if="it.demand_type == 1">出售轉讓</div>
                  <div class="news_item_time">
                    <div>
                      {{ $dayjs(it.end_time).format("YYYY-MM-DD") }} 截止
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="+ 發布采購" name="1">
          <el-tabs class="need-tabs">
            <el-tab-pane>
              <span slot="label">
                <div class="type-card">
                  <img src="../assets/imgs/need01.png" />
                  <h3>采購訂單</h3>
                  <p>
                    采購貨物，比如工業設備、服飾生鮮、家居生活、數碼設備、圖書等等
                  </p>
                </div>
              </span>
              <div class="needs-form">
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i> 標題：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="needsForm.title"
                      placeholder="提煉需求內容，比如XXXXXXXX，建議填寫多種標簽名稱，20字以內"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>圖片：</el-col>
                  <el-col :span="16">
                    <el-upload
                      action="https://upload.qiniup.com/"
                      :data="qn"
                      list-type="picture-card"
                      :on-success="handleLogoSuccess"
                      :before-upload="beforeAvatarUpload"
                      :on-remove="handleRemove"
                      :limit="5"
                      :file-list="fileList"
                    >
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <p slot="tip" class="tips">
                        您需要最少上傳 1
                        張圖片用於描述您的需求，建議上傳需求的全貌，最多可上傳 5
                        張
                      </p>
                    </el-upload>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>采購量：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="needsForm.params[0].value"
                      placeholder="采購數額（請標明單位）"
                    ></el-input>
                  </el-col>
                  <!-- <el-col :span="2">
                    <p class="tips">請標明單位</p>
                  </el-col> -->
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">截止日期：</el-col>
                  <el-col :span="16">
                    <el-date-picker
                      v-model="needsForm.end_time"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="timestamp"
                      type="date"
                      placeholder="采購截止日期"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">采購需求：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="needsForm.params[1].value"
                      placeholder="比如品質、商品規格等要求信息"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">交貨需求：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="needsForm.params[2].value"
                      placeholder="比如交貨方式，交貨地點"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">其他：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="needsForm.params[3].value"
                      placeholder="額外的備註內容（選填）"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>聯系電話：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="needsForm.params[4].value"
                      placeholder="建議使用您賬號相同的手機號"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"></el-col>
                  <el-col :span="16" class="tag">
                    <el-button type="primary" @click="pubilsh(0)">
                      發布需求
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label">
                <div class="type-card">
                  <img src="../assets/imgs/need02.png" />
                  <h3>出售轉讓</h3>
                  <p>處理房產地皮、公司轉讓，這裏填寫出售轉讓的信息描述等等</p>
                </div>
              </span>
              <div class="needs-form">
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>輸入需求地址：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.addr"
                      placeholder="填寫詳細的需求地址 "
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>資產名稱：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.title"
                      placeholder="提煉需求內容，比如XXXXXXXX，建議填寫多種標簽名稱，20字以內"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>圖片：</el-col>
                  <el-col :span="16">
                    <el-upload
                      action="https://upload.qiniup.com/"
                      :data="qn"
                      list-type="picture-card"
                      :on-success="handleLogoSuccess2"
                      :before-upload="beforeAvatarUpload2"
                      :on-remove="handleRemove2"
                      :limit="5"
                      :file-list="fileList2"
                    >
                      <i class="el-icon-plus"></i>
                      <p slot="tip" class="tips">
                        您需要最少上傳 1
                        張圖片用於描述您的需求，建議上傳需求的全貌，最多可上傳 5
                        張
                      </p>
                    </el-upload>
                    <!-- <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog> -->
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i> 訴求：</el-col>
                  <el-col :span="16">
                    <el-radio
                      v-model="saleForm.params[0].value"
                      label="出售"
                      border
                    >
                      出售
                    </el-radio>
                    <el-radio
                      v-model="saleForm.params[0].value"
                      label="轉讓"
                      border
                    >
                      轉讓
                    </el-radio>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>價格：</el-col>
                  <el-col :span="16">
                    <el-col :span="6">
                      <el-radio
                        v-model="saleForm.params[1].value"
                        label="價格面議"
                        border
                      >
                        價格面議
                      </el-radio>
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="saleForm.params[1].value"
                        placeholder="总价或每平米單價"
                      ></el-input>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">截止日期：</el-col>
                  <el-col :span="16">
                    <!-- <el-input
                      v-model="saleForm.end_time"
                      placeholder="采購截止日期"
                    ></el-input> -->
                    <el-date-picker
                      v-model="saleForm.end_time"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="timestamp"
                      type="date"
                      placeholder="截止日期"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">面積：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.params[2].value"
                      placeholder="比如總建築面積、產證面積"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">類型：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.params[3].value"
                      placeholder="比如商場、寫字樓"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>有無商業糾紛：</el-col>
                  <el-col :span="16">
                    <el-radio
                      v-model="saleForm.params[4].value"
                      label="有"
                      border
                    >
                      有
                    </el-radio>
                    <el-radio
                      v-model="saleForm.params[4].value"
                      label="無"
                      border
                    >
                      無
                    </el-radio>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">亮點：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="saleForm.params[5].value"
                      placeholder="…"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag">其他：</el-col>
                  <el-col :span="16">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 3 }"
                      v-model="saleForm.params[6].value"
                      placeholder="額外的備註內容（選填）"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="tag"><i>*</i>聯系電話：</el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="saleForm.params[7].value"
                      placeholder="建議使用您賬號相同的手機號"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="tag"></el-col>
                  <el-col :span="16" class="tag">
                    <el-button type="primary" @click="pubilsh(1)">
                      發布需求
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import * as qiniu from "qiniu-js";

export default {
  data() {
    return {
      investListRes: [],
      needListRes: [],
      start: 0,
      limit: 5,
      qn: {
        token: "",
        // key: "avatar_" + Date.now() + "_" + Math.random(),
      },
      active: "0",
      navList: [
        // {
        //   type_name: "項目投資",
        //   type: "invest",
        // },
        // {
        //   type_name: "訂單訊息",
        //   type: "order",
        // },
        {
          type_name: "需求列表",
          type: "",
        },
        {
          type_name: "+ 發布采購",
          type: "",
        },
      ],
      // demand_type（0采购订单，1出售转让）
      needsForm: {
        demand_type: 0,
        title: "",
        main_image: [],
        member_id: this.user_id,
        end_time: "",
        params: [
          {
            name: "采购量",
            value: "",
          },
          {
            name: "采购需求",
            value: "",
          },
          {
            name: "交货需求",
            value: "",
          },
          {
            name: "其他",
            value: "",
          },
          {
            name: "聯系電話",
            value: "",
          },
        ],
        // phone: "",
      },
      saleForm: {
        demand_type: 1,
        title: "",
        addr: "",
        main_image: [],
        member_id: this.user_id,
        end_time: "",
        params: [
          {
            name: "诉求",
            value: "",
          },
          {
            name: "价格",
            value: "",
          },
          {
            name: "面积",
            value: "",
          },
          {
            name: "類型",
            value: "",
          },
          {
            name: "有无商业纠纷",
            value: "",
          },
          {
            name: "亮点",
            value: "",
          },
          {
            name: "其他",
            value: "",
          },
          {
            name: "聯系電話",
            value: "",
          },
        ],
        // phone: "",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      fileList2: [],
    };
  },
  props: {
    article_type: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["user_id", "isPc", "validToken"]),
    investList() {
      return this.investListRes.map((item) => {
        if (item.main_image) {
          item.main_image = item.main_image.split(",");
          item.main_image = item.main_image.map((item) => {
            return !/^http/.test(item) ? this.$imgUrl + item : item;
          });
          // item.end_time = dayjs(item.end_time.time).format("YYYY-MM-DD");
        }
        return item;
      });
    },
  },
  watch: {
    active(val) {
      if (val == 1) {
        if (!this.validToken) {
          this.$store.state.isDialogVisible = true;
        }
      }
    },
  },
  methods: {
    handleClick(tab, event) {
      this.active = tab.index;
      // this.getInvestList();
      // this.article_type=this.rowMenuList[tab.index].type_id
    },

    async getInvestList() {
      const { data: res } = await this.$http.get("/api/v2/investInfo/list", {
        params: {
          // start: this.start,
          // limit: this.limit,
          type: this.navList[this.active].type,
          association_id: "SZTX",
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.investListRes = res.data;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    async getNeedList() {
      const { data: res } = await this.$http.get("/api/v2/demand/list", {
        params: {
          searchJson: {
            association_id: "SZTX",
            review: 2,
          },
          // start: this.start,
          // limit: this.limit,
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.needListRes = eval("(" + res.data + ")").data;
      this.needListRes = this.needListRes.map((item) => {
        if (item.main_image) {
          item.main_image = item.main_image.split(",");
          item.main_image = item.main_image.map((item) => {
            return !/^http/.test(item) ? this.$imgUrl + item : item;
          });
          item.end_time = item.end_time.time;
        }
        return item;
      });

      // console.log(JSON.parse(res.data))
      console.log(eval("(" + res.data + ")").data);
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    fnToGetMore() {
      this.start += this.limit;
      this.getInvestList();
    },
    fnToArticle(info_id) {
      console.log(info_id);
      this.$router.push({
        path: `/investInfo/${info_id}`,
      });
    },
    fnToNeed(demand_id) {
      console.log(demand_id);
      this.$router.push({
        path: `/need-details/${demand_id}`,
      });
    },
    async pubilsh(th) {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        if (th == 0) {
          console.log(this.fileList);
          // this.fileList.map((item) => {
          // this.needsForm.main_image.push(this.$imgUrl+item.response.key);
          // });

          this.needsForm.main_image = this.listToString(this.fileList);
          this.needsForm.param = JSON.stringify(this.needsForm.params);
          console.log(JSON.stringify(this.needsForm.param));
          this.needsForm.member_id = this.user_id;
          console.log(this.needsForm);
          const { data: res } = await this.$http.post(
            `/api/v2/demand/addDemand`,
            this.needsForm
          );
          if (!res.sucess) return this.$message.error("失敗");
          this.$message.success("發佈成功");
          this.$router.push({
            path: `/my_need`,
          });
        } else {
          // this.fileList2.map((item) => {
          //   this.saleForm.main_image.push(item.url);
          // });
          this.saleForm.main_image = this.listToString(this.fileList2);
          this.saleForm.param = JSON.stringify(this.saleForm.params);
          console.log(JSON.stringify(this.saleForm.param));
          this.saleForm.member_id = this.user_id;
          console.log(this.saleForm);
          const { data: res } = await this.$http.post(
            `/api/v2/demand/addDemand`,
            this.saleForm
          );
          if (!res.sucess) return this.$message.error("失敗");
          this.$message.success("發佈成功");
          console.log(this.saleForm);
          this.$router.push({
            path: `/my_need`,
          });
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    handleLogoSuccess(res, file, fileList) {
      console.log(file);
      // this.fileList = fileList;
      this.fileList.push({
        name: res.key,
        url: this.$imgUrl + res.key,
      });
      // console.log(res)
      // this.fnUploadFile(file.raw);
    },
    handleChange(file, fileList) {
      console.log("ssss===", fileList);
      // this.fileList = fileList.slice(-3);
    },
    beforeAvatarUpload(file) {
      // console.log('文件大小======',file)
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isMp4 = file.type === "video/mp4";
      const isLt6M = file.size / 1024 / 1024 < 20;

      if (!isPNG && !isJPEG && !isJPG && !isMp4) {
        this.$message.error("上傳圖片只能是jpg、png、jpeg格式!");
        return false;
      }
      if (!isLt6M) {
        this.$message.error("上傳圖片大小不能超過 20MB!");
        return false;
      }
    },
    //上传图片至七牛云
    fnUploadFile(raw, th) {
      let vm = this;
      let key = "avatar_" + Date.now() + "_" + Math.random();
      let file = raw;
      var putExtra = {
        fname: key,
        mimeType: ["image/png", "image/jpeg", "image/gif"], //限制上传类型
      };
      let config = {
        useCdnDomain: true,
        region: qiniu.region.z0,
      };
      let observer = {
        next(res) {
          // ...
        },
        error(err) {
          // console.log('失败====',err);
        },
        complete(res) {
          // console.log('上传图片====',JSON.stringify(res))
          let img = {
            name: key,
            url: vm.$imgUrl + res.key,
          };
          vm.fileList.push(img);
          // console.log(vm.fileList)
        },
      };
      var observable = qiniu.upload(file, key, this.qn.token, putExtra, config);
      var subscription = observable.subscribe(observer); // 上传开始
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
      this.fileList2 = fileList;
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    handleLogoSuccess2(res, file, fileList) {
      // console.log(file)
      // console.log(res)
      // this.fnUploadFile2(file.raw);
      // this.fileList2 = fileList;
      this.fileList2.push({
        name: res.key,
        url: this.$imgUrl + res.key,
      });
    },
    handleChange2(file, fileList) {
      console.log("ssss===", fileList);
      // this.fileList = fileList.slice(-3);
    },
    beforeAvatarUpload2(file) {
      // console.log('文件大小======',file)
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt6M = file.size / 1024 / 1024 < 20;

      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error("上傳圖片只能是jpg、png、jpeg格式!");
        return false;
      }
      if (!isLt6M) {
        this.$message.error("上傳圖片大小不能超過 20MB!");
        return false;
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    },
    async getQiniuToken() {
      const { data: res } = await this.$http.get(`/api/v2/qiniu/getUptoken`);
      if (!res.sucess) return this.$message.error("獲取失敗");
      this.qn.token = res.data;
      // console.log("七牛云=====", res);
    },
  },
  created() {
    this.getQiniuToken();
    this.getInvestList();
    this.getNeedList();
  },
};
</script>
<style lang="less" scoped>
.investList {
  background: #f2f2f2;
}
.el-main {
  width: 1200px;
  padding-top: 50px;
  margin-bottom: 0;
  padding-bottom: 50px;
}

/deep/.el-tabs__header {
  width: 140px;
  margin-right: 32px !important;
  border-radius: 4px;
  // overflow: hidden;
  .el-tabs__nav-wrap::after {
    content: none;
  }
  .el-tabs__item {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #222222;
    font-weight: 400;
    // padding: 8px;
    height: 40px;
    line-height: 40px;
    text-align: center !important;
    background: #fff;
  }
  .el-tabs__item.is-active {
    color: #ffffff;
    background: #20317f;
  }
  .el-tabs__item:hover {
    color: #20317f !important;
  }
  .el-tabs__item.is-active {
    color: #ffffff !important;
  }
  .el-tabs__active-bar {
    background-color: transparent;
  }
  .is-left #tab-1 {
    background: #007aff;
    border-radius: 8px;
    margin-top: 40px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
    padding: 13px 40px;
    height: auto;
  }
}
/deep/.need-tabs {
  .el-tabs__header {
    width: auto;
    margin: 0 !important;
    .el-tabs__active-bar {
      display: none;
    }
    .el-tabs__nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    .el-tabs__item {
      border-radius: 8px;
      border: 2px solid #f2f2f7;
      height: auto;
      width: 49%;
      padding: 0;
      .type-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px;
        img {
          width: 42px;
          height: 42px;
          object-fit: contain;
        }
      }
      h3 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #2c2c2e;
        line-height: 25px;
        margin: 10px 0;
      }
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #aeaeb2;
        line-height: 20px;
      }
    }
    .el-tabs__item.is-active {
      background: #fff;
      border: 2px solid #2c2c2e;
    }
  }
  .el-tabs__content {
    background: #ffffff;
    padding: 20px 30px;
    border-radius: 8px;
    margin-top: 20px;
    .needs-form {
      .el-row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .tips {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff3b30;
          line-height: 20px;
          // margin-top: 10px;
          margin-left: 10px;
        }
        .el-col-3 {
          padding-left: 10px;
        }
      }
      .tag {
        position: relative;
        i {
          position: absolute;
          left: -12px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff3b30;
          line-height: 22px;
        }
      }
      .el-upload {
        width: 100px;
        height: 100px;
        line-height: 106px;
        margin-bottom: 10px;
        background: #fff;
        border: 1px dashed #aeaeb2;
        border-radius: 8px;
        i {
          color: #2c2c2e;
          font-weight: bolder;
        }
      }
      .el-upload-list--picture-card .el-upload-list__item {
        width: 100px;
        height: 100px;
      }
      .el-dialog__wrapper {
        z-index: 2012;
      }
    }
    .el-button {
      font-size: 16px !important;
      font-family: PingFangSC-Semibold, PingFang SC !important;
      font-weight: 600 !important;
      color: #ffffff !important;
      line-height: 22px !important;
      padding: 13px 30px !important;
      background: #007aff !important;
      border-radius: 8px !important;
    }
  }
}

.el-button {
  width: 100%;
  font-size: 14px !important;
  color: #878787 !important;
  line-height: 22px !important;
  padding: 10px 0 !important;
  background: #fbfbfb !important;
  border: none !important;
}
.news_item {
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  .el-image {
    width: 100%;
    // height: auto;
    height: 220px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
  .news_item_info {
    padding: 10px 15px 15px;
    height: 93px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: -webkit-fill-available;
    h3 {
      font-size: 22px;
      line-height: 34px;
      margin-bottom: 10px;
      font-family: MicrosoftYaHei;
      color: #222222;
      font-weight: 400;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
      font-family: MicrosoftYaHei;
      color: #888888;
      font-weight: 400;
    }
    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }
    .el-icon-view:before {
      margin-right: 5px;
    }
    .types {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #007aff;
      line-height: 17px;
    }
    .red {
      color: #ff3b30;
    }
  }
}
@media screen and (max-width: 768px) {
  /deep/.el-tabs__header{
    width: auto;
  }
  .need-lists {
    background: #f8f8f8;
    padding: 10px 15px;
  }
  .news_item {
    padding: 5px 0;
    .el-image {
      width: 100%;
      height: 120px;
      margin-right: 0;
      img {
        border-radius: 8px;
      }
    }
    .news_item_info {
      h3 {
        font-size: 16px;
        line-height: 28px;
        color: #000;
        margin-bottom: 5px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .news_item_time {
        font-size: 12px;
        color: #333333;
        margin-right: 10px;
      }
    }
  }
  .el-button {
    width: 80%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
    margin: 10px auto;
    display: block;
  }
  .need-tabs{
    .el-tabs__header{
.el-tabs__item{
      .type-card{
        padding: 10px;
      }
      p{
        white-space: break-spaces;
      }
    }
    }
    
  }
}
/deep/.el-progress-circle {
  width: 90px !important;
  height: 90px !important;
}
</style>
<style>
/* .v-modal{
  display: none;
} */
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain;
}
.el-upload-list--picture-card .el-progress {
  width: 90px !important;
}
</style>